export function isDebugEnabled(flag: 'ws' | 'room' | 'all'): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const debug = params.get('debug');
  if (!debug) return false;
  if (debug === 'all') return true;
  return debug === flag;
}
